<template>
    <h3
        class="mb-5 whitespace-pre-line text-pretty px-2 text-[1.25rem] font-bold leading-[1.3] sm:px-5 sm:text-[1.5rem] lg:text-[1.625rem]"
    >
        <slot />
    </h3>
</template>
